import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { IngredienteProdutoViewModel } from "src/app/shared/models/produto.model";

@Component({
    selector: 'app-cadastro-ingredientes',
    templateUrl: './cadastro-ingredientes.page.html',
    styleUrls: ['./cadastro-ingredientes.page.scss'],
})
export class CadastroIngredientesPage implements OnInit, OnChanges {
    @Input() ingredientesAdicionados: IngredienteProdutoViewModel[] = [];
    @Input() listaIngredientes: IngredienteProdutoViewModel[] = [];
    @Input() carregando: boolean = false;
    @Input() enviando: boolean = false;
    @Input() nomeSabor: string = '';

    @Output() addIngrediente = new EventEmitter<string>();
    @Output() removerIngrediente = new EventEmitter<IngredienteProdutoViewModel>();

    public ingredienteCtrl = new FormControl('');
    public ingredientesFiltrados!: Observable<IngredienteProdutoViewModel[]>;

    constructor() {}

    ngOnInit(): void {
        this.ingredientesFiltrados = this.ingredienteCtrl.valueChanges.pipe(
            startWith(null),
            map((ingrediente: string | null) => (ingrediente ? this.filtrarIngredientes(ingrediente) : this.listaIngredientes.slice())),
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['listaIngredientes']) {
            this.ingredienteCtrl.setValue(this.ingredienteCtrl.value);
        }
    }

    private filtrarIngredientes(value: string): IngredienteProdutoViewModel[] {
        const filterValue = value.toLowerCase();
        return this.listaIngredientes.filter(ingrediente => ingrediente.nome.toLowerCase().includes(filterValue));
    }

    public onAddIngrediente(event: any): void {
        let value = this.ingredienteCtrl.value?.trim();        
        
        if (event && event.value) { 
            value = (event.value || '').trim();
            if (event.chipInput) {
                event.chipInput!.clear();
            }
        }

        if (!value || value.length === 0) return;

        this.addIngrediente.emit(value);
        this.ingredienteCtrl.setValue(null);
    }

    public onSelectedIngrediente(event: any): void {
        const ingredienteStr = event.option.value;
        if (!ingredienteStr) return;

        this.addIngrediente.emit(ingredienteStr);
        this.ingredienteCtrl.setValue(null);
    }

    public onRemoverIngrediente(ingrediente: IngredienteProdutoViewModel): void {
        this.removerIngrediente.emit(ingrediente);
    }
}
